<template>
    <div>
        <b-row class="mb-2 text-right">
            <b-col>
                <b-button-group>
                    <b-button @click="addProductCategory" class="btn btn-light mr-2">{{Core.Definition.getDefinition('Nouvelle catégorie')}}</b-button>
                    <b-button @click="gotoProductCategories" class="btn btn-light mr-2">{{Core.Definition.getDefinition('Catégories')}}</b-button>
                    <b-button @click="add" class="btn btn-light">{{Core.Definition.getDefinition('Nouveau produit')}}</b-button>
                </b-button-group>
            </b-col>
        </b-row>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: 'ProductContainer',
        components: {
        },
        mounted() {
        },
        data () {
            return {
                Core: window.Core
            }
        },
        methods: {
            add() {
                if (this.$route.fullPath === window.Core.Definition.getDefinition('/commerce/produits/nouveau-produit')) {
                    location.reload()
                } else {
                    this.$router.push(window.Core.Definition.getDefinition('/commerce/produits/nouveau-produit'))
                }
            },
            addProductCategory() {
                this.$router.push(window.Core.Definition.getDefinition('/commerce/produits/categories/nouvelle-categorie'))
            },
            gotoProductCategories() {
                this.$router.push(window.Core.Definition.getDefinition('/commerce/produits/categories'))
            }
        }
    }
</script>
